import { render, staticRenderFns } from "./PrizeDetail.vue?vue&type=template&id=6694e8cc&"
import script from "./PrizeDetail.vue?vue&type=script&lang=js&"
export * from "./PrizeDetail.vue?vue&type=script&lang=js&"
import style0 from "./PrizeDetail.vue?vue&type=style&index=0&id=6694e8cc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports